import React from 'react';
import { useForm } from 'react-hook-form';
import { usePushEvents } from '../../../../hooks/PushEvents';
import {
    loginPopupAddressCityScreenNext,
    loginPopupAddressCityScreenShown,
} from '../../../../hooks/PushEvents/clevertapEvents';
import type { AddressData } from '../address1Step';

export type Address2FormValues = {
    city: string;
    state: string;
};

export const useAddress2Step = (
    onAddress2Submit: (city: string, state: string) => void,
    address: AddressData | undefined,
) => {
    const { pushEvent } = usePushEvents();
    const {
        register,
        handleSubmit,
        control,
        formState: { errors },
    } = useForm<Address2FormValues>({
        defaultValues: {
            city: address?.city ?? '',
            state: address?.state ?? '',
        },
    });

    React.useEffect(() => {
        pushEvent(loginPopupAddressCityScreenShown);
        // run only once when component is mounted
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const onSubmit = handleSubmit((data) => {
        pushEvent(loginPopupAddressCityScreenNext);
        onAddress2Submit(data.city, data.state);
    });

    const isUS = (address?.countryCode ?? 'US') === 'US';

    return { register, control, errors, onSubmit, isUS };
};
